import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseListComponent } from 'src/modules/sm-base/components/admin-base-list/admin-base-list.component';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Objects } from "src/modules/utils/shared/objects";
import { ProjectPlanningTools } from "../../models/project-planning-tools.model";
import { ResourceType } from '../../netgen/ResourceType';

@Component({
    selector: 'app-edit-resource-types',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditResourceTypesComponent extends AdminBaseListComponent<ResourceType> {

    definition = ProjectPlanningTools.definitionResourceType;

    getTable(): TableData {
        return this.app.tTable("entity.ResourceType.fields", new TableData([
            new TableColumn("color", "", TableCellType.color, 1),
            new TableColumn("title", "", TableCellType.string, -1)
        ],  this.listData.map(o => new TableRow(Objects.toString(o.id), o, o)), ["title"]));
    }

}
